import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../state/store";
import { loginUser, clearError } from "../../state/authSlice";
import "./Login.css";
import GradientButton from "../../components/button/Button";
import { Logo } from "../../images/Images";
import LoadingComponent from "../../components/loading/Loading";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";

const Login: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { loading, error, token, business_type } = useSelector(
    (state: RootState) => state.auth
  );
  

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearError());

    const result = await dispatch(loginUser({ email, password }));

    if (loginUser.fulfilled.match(result)) {
      toast.success("Login successful!");
      // Only call getUserStatus after login
      const verified = await getUserStatus();

      if (!verified) return; // User is redirected to verify page
      console.log("object", result);

      const userBusinessType = result.payload.business_type;
      console.log(userBusinessType);

      if (userBusinessType === "wholesaler") {
        checkVentureState();
      } else if (userBusinessType === "retailer") {
        window.location.href = "/all-vendors";
      } 
    } else if (loginUser.rejected.match(result)) {
      toast.error(result.payload as string);
    }
  };

  // Redirect to dashboard if already logged in

  const checkVentureState = async () => {
    const verified = await getUserStatus();
    if (!verified) return; // User is redirected to verify page

    try {
      const res = await axiosInstance.get("/ventures/me");
      if (res.data.data) {
        console.log("object", res.data.data);
        window.location.href = "/dashboard";
      } else {
        window.location.href = "/create-business";
      }
    } catch (error) {
      // window.location.href = "/create-business";
    }
  };

  const getUserStatus = async () => {
    try {
      const res = await axiosInstance.get("/auth/me");
      const isVerified = res.data.data.is_verified_email;
      const userEmail = res.data.data.email;
      const userId = res.data.data.id;

      console.log(res.data);

      // Only store if not verified
      if (userEmail && !isVerified) {
        localStorage.setItem("verify_username", userEmail);
        localStorage.setItem("verify_status", "false");
        localStorage.setItem("verify_id", userId);
        // Redirect to verify email page if not verified
        window.location.href = "/verify-email";
        return false;
      } else {
        // Clean up if verified
        localStorage.removeItem("verify_username");
        localStorage.removeItem("verify_status");
        localStorage.removeItem("verify_id");
      }
      return true;
    } catch (error) {
      localStorage.setItem("verify_status", "false");
      window.location.href = "/verify-email";
      return false;
    }
  };

  // if (loading) {
  //   return <LoadingComponent />;
  // }

  return (
    <div className="login-page">
      {/* Left-side Image */}
      <div className="login-page__image">
        <img
          src="https://img.freepik.com/free-photo/top-view-vegetables-fruits-zucchini-bell-peppers-apples-quince-cherry-tomatoes-cumcuat-parsley-cabbage-lemon-pomegranates_140725-59438.jpg?uid=R27806234&ga=GA1.1.1852762410.1725342281&semt=ais_hybrid"
          alt="Fresh Produce"
        />
      </div>

      {/* Right-side Form */}
      <div className="login-page__form-container">
        <form className="login-page__form" onSubmit={handleLogin}>
          <div className="login-page__title">
            <img src={Logo} alt="logo" />
          </div>
          <h2 className="login-page__subtitle">Welcome Back</h2>
          <p className="login-page__description">Enter your details to login</p>

          {/* Input Fields */}
          <div className="login-page__input-group">
            <label>Email Address</label>
            <input
              type="email"
              placeholder="Eg. johndoe@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="login-page__input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* Forgot Password */}
          <div className="login-page__forgot-password">
            <a href="/forgot-password">Forgot Password?</a>
          </div>

          <div className="gd-btn">
            <GradientButton
              text={loading ? "Logging in..." : "Login"}
              disabled={loading}
            />
          </div>

          {/* Sign Up Link */}
          <div className="login-page__signup">
            <p>
              Don’t have an account? <a href="/signup">Sign up</a>
            </p>
          </div>

          {/* Error Message */}
          {/* {error && <p className="login-page__error">{error}</p>} */}
        </form>
      </div>
    </div>
  );
};

export default Login;
